import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDynamicDashboardModule } from '@mare-common/ngx-dynamic-dashboard';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { IndicatorComponent } from 'src/app/shared/indicator/indicator.component';
import { ChartConfigService } from 'src/app/services/chart-config.service';
import { ChartBuilderService } from 'src/app/services/chart-builder.service';
import { Subject, takeUntil } from 'rxjs';
import { identifierName } from '@angular/compiler';
import { MatCardModule } from '@angular/material/card';
import { Platform } from '@angular/cdk/platform';
import { LandingService } from 'src/app/services/landing.service';
import { fadeInUpAnimation } from 'src/app/shared/animations/animations';

@Component({
  selector: 'company-balance',
  standalone: true,
  imports: [CommonModule,
    SharedModule,
    TranslateModule,
    NgxDynamicDashboardModule,
    IndicatorComponent,
    MatCardModule
  ],
  animations:[fadeInUpAnimation],
  templateUrl: './company-balance.component.html',
  styleUrls: ['./company-balance.component.scss']
})
export class CompanyBalanceComponent implements OnInit {
  @Input() company: any;
  @Input() ateco!: string;
  @Input() piva!: string;
  @Input() showFinancialMatrix?: boolean = true;

  visibilityState: { [key: string]: string } = {
    charts: 'inactive',
    metrix:'inactive'
  };
  revealedInViewport: boolean = false;

  financialMetrix!: Array<any>
  fatturatoChart: any;
  profitsChart: any;
  private unsubscribe$ = new Subject<void>();
  isInViewport: boolean = false;

  isMobile: boolean;

  revenues: Array<number> = []
  revenuesaverages: Array<number> = [];
  profits: Array<number> = [];
  protifsaverages: Array<number> = [];
  


  constructor(
    private chartConfigService: ChartConfigService,
    private chartBuilderService: ChartBuilderService,
    private platform: Platform,
    private landingService: LandingService
  ) {
    this.isMobile = this.IsMobile();

   }
  ngOnInit(): void {
    this.initCharts(this.ateco);
    if(this.showFinancialMatrix){
      this.initFinancialMetrix();
    }
  }
  onIsInViewport(event:any) {
    if (!this.isInViewport && this.fatturatoChart && this.profitsChart) {
      this.isInViewport = true;
      this.updateChartData();
    }
  }
  onViewportChange(elementId: string, isInViewport: boolean) {
		if(Object.keys(this.visibilityState).includes(elementId) && isInViewport) {
			this.visibilityState[elementId] = '*';
		}
	  }
  initFinancialMetrix() {
    let latestStatement = this.company?.localFinancialStatements.sort((a: any, b: any) => new Date(b.yearEndDate).getTime() - new Date(a.yearEndDate).getTime())[0];
    let companyRatios = latestStatement?.ratios;
    if(companyRatios){
      this.financialMetrix =  [
      {
        title: 'R.O.I.',
        value: companyRatios.returnOnInvestmentPercentage+'%',
        icon:'signal_cellular_alt',
        rating:companyRatios.returnOnInvestmentPercentage > 0 ? 'positive' : 'warning'
      },
      {
        title: 'R.O.S.',
        value: companyRatios.returnOnSalesPercentage+'%',
        icon:'signal_cellular_alt',
        rating:companyRatios.returnOnSalesPercentage > 0 ? 'positive' : 'warning'
      },
      {
        title: 'R.O.E.',
        value: companyRatios.returnOnEquityPercentage+'%',
        icon:'signal_cellular_alt',
        rating:companyRatios.returnOnEquityPercentage > 0 ? 'positive' : 'warning'
      },
    ];
    }
  }

  manageFinancilaData(localFinancialStatements: any, financialIstatAverages:any) {
    return new Promise((resolve) => {
       let anni: Array<any> = []
    let filteredData = localFinancialStatements.filter((data: any) => data.type == 'LocalFinancialsCSIT').forEach((data: any) => {
      let anno = new Date(data.yearEndDate).getFullYear();
      let avgelement = financialIstatAverages.find((data: any) => data.year == anno);

      let obj = {
        revenue: data.profitAndLoss.totalValueOfProduction,
        revenueAverage: avgelement?.revenue ?? 0,
        profitloss: data.profitAndLoss.ebitda,
        profitLossAverage: avgelement?.profitLoss ?? 0,
        year : anno 
      }
      anni.push(obj);
     
    });
      anni = anni.sort((a: any, b: any) => a.year - b.year);
      resolve(anni)
    })
  }

  initCharts(ateco:string) {
    if (!ateco)
      return;
    //split modify string by adding a point each 2 characters
   
    ateco = ateco.replace(/(.{2})(?=.)/g, "$1.");

      let data = this.chartConfigService.retrieveFatturatoUtileMercato(ateco);
    this.landingService.getDashboard().then((res: any) => {
      console.log(res);
      if(res && res.istat){
          let financialAverage = res.istat.dettagli_finanziari_settore.map((item: any) => {
          return {
            year: item.anno,
            revenue: item.ricavi,// traduci revenue in italiano = 
            profitLoss: item.profit_loss
          }
        });
        this.manageFinancilaData(this.company.localFinancialStatements, financialAverage).then((res: any) => {
          this.buildBarChart(res)
        })
      } 
    })
    
    // this.chartConfigService.makeChartDataApiCall(data).then((response: any) => {
    //   console.log(response.payload[0].result);
    //       this.manageFinancilaDataOrig(this.company.localFinancialStatements, response.payload[0].result).then((res: any) => {
    //           this.buildBarChart(res)
    //       })
    //   });// end promise

  }


  buildBarChart(anni: Array<any>) {
   
    let colorsRevenues: Array<string> = [];
    let colorsProfits: Array<string> = [];
    let initialRevenues: Array<{ id: string, data: string | number, year: number }> = [];
    let initialRevenuesaverages: Array<{ id: string, data: string | number, year: number }> = [];
    let initialProfits: Array<{ id: string, data: string | number, year: number }> = [];
    let initialProtifsaverages: Array<{ id: string, data: string | number, year: number }> = [];
		for (const val of anni) {
      this.revenues.push(val.revenue);
      this.revenuesaverages.push( val.revenueAverage);
      this.profits.push(val.profitloss);
      this.protifsaverages.push(val.profitLossAverage);

    //  initialRevenues.push({ id: val.year, data: 0, year: val.year });
    //  initialRevenuesaverages.push({ id: val.year, data: 0, year: val.year });
    //  initialProfits.push({ id: val.year, data: 0, year: val.year });
    //   initialProtifsaverages.push({ id: val.year, data: 0, year: val.year });
      
      initialRevenues.push({ id: val.year, data: val.revenue, year: val.year });
     initialRevenuesaverages.push({ id: val.year, data: val.revenueAverage, year: val.year });
     initialProfits.push({ id: val.year, data: val.profitloss, year: val.year });
     initialProtifsaverages.push({ id: val.year, data: val.profitLossAverage, year: val.year });

      if (val.revenue > 0) {
        colorsRevenues.push('#00E809');
      } else {
        colorsRevenues.push('#fdc400');
      }
      if (val.profitloss > 0) {
        colorsProfits.push('#00E809');
      } else {
        colorsProfits.push('#fdc400');
      }
    }
    let config = {
			displayModeBar: false,
			modeBarButtonsToRemove: ['toImage'],
			displaylogo: false,
    }
    let helpTitleFatturato = 'Fatturato';
    let helpDescriptionFatturato = 'Abbiamo confrontato l\'andamento del tuo fatturato, con la media del settore ATECO ('+this.ateco+') di appartenenza ';
    let helpTitleUtile = 'Utile';
    let helpDescriptionUtile = 'Abbiamo confrontato l\'andamento del tuo utile, con la media del settore ATECO ('+this.ateco+') di appartenenza ';
    let _graphicDataOverview: any = this.chartBuilderService.buildChartAverages(anni, 'fatturatoComp', initialRevenues, initialRevenuesaverages, 'Fatturato a confronto con Media di settore', 'Azienda', 'Media di settore', colorsRevenues, '#0025ff', helpTitleFatturato, helpDescriptionFatturato);
    _graphicDataOverview.graphic.config = config;
    _graphicDataOverview.graphic.layout = Object.assign(_graphicDataOverview.graphic.layout, {
      yaxis: {
        range: [Math.min(...this.revenuesaverages, ...this.revenues), Math.max(...this.revenuesaverages, ...this.revenues)],
        fixedrange: true
      },
      xaxis:{
        fixedrange: true}
    });
   
    let _graphicData2Overview: any = this.chartBuilderService.buildChartAverages(anni, 'profittiComp', initialProfits, initialProtifsaverages, 'Utile a confronto con Media di settore', 'Azienda', 'Media di settore', colorsProfits, '#0025ff', helpTitleUtile, helpDescriptionUtile);
    _graphicData2Overview.graphic.config = config;
    _graphicData2Overview.graphic.layout = Object.assign(_graphicData2Overview.graphic.layout, {
      yaxis: {
        range: [Math.min(...this.protifsaverages, ...this.profits), Math.max(...this.protifsaverages, ...this.profits)],
        fixedrange: true
      },
      xaxis:{
        fixedrange: true}
    })
    if (this.isMobile) {
      _graphicDataOverview.graphic.layout.margin = { t: 0, b: 0, l: 0, r: 0 };
      // set plotly width to 300
      _graphicDataOverview.graphic.data.width = 300;
      _graphicData2Overview.graphic.data.height = 200;
      _graphicData2Overview.graphic.layout.margin = { t: 0, b: 0, l: 0, r: 0 };
      _graphicData2Overview.graphic.data.width = 300;
      _graphicData2Overview.graphic.data.height = 200;
    } 
     
    this.fatturatoChart = _graphicDataOverview;
    this.profitsChart = _graphicData2Overview;
  
  }

  IsMobile() {
    const regex = new RegExp(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i, 'g');
    // console.log(navigator.userAgent,regex)
    if(regex.test(navigator.userAgent)){
        return true
    }
    else if (window.innerWidth < 1024) {
        return true
    }
    else{
      return false
    }
}

  updateChartData() {
    if(this?.fatturatoChart?.graphic?.data){
      this.fatturatoChart.graphic.data[0].y = this.revenues;
      this.fatturatoChart.graphic.data[1].y = this.revenuesaverages;
    }
    if(this?.profitsChart?.graphic?.data){
      this.profitsChart.graphic.data[0].y = this.profits;
      this.profitsChart.graphic.data[1].y = this.protifsaverages;
    }
  }
  ngonDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
